import { useRuntimeConfig } from '#imports'

import type { DataLayerEvent } from '../../../types'

export function pushEventToStagingDataLayer(event: DataLayerEvent) {
  if (!import.meta.client) return

  const {
    public: { GTM_EVENTS_MIGRATION_LOGS_ACTIVATED },
  } = useRuntimeConfig()

  if (!GTM_EVENTS_MIGRATION_LOGS_ACTIVATED) return

  window.stagingDataLayer ??= []
  window.stagingDataLayer.push(event)
}
